import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const MONTHS = ["Janv", "Févr", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"];
const key = (y, m) => `${y}-${String(m + 1).padStart(2, "0")}`;
const label = (k) => (k ? `${MONTHS[Number(k.slice(5, 7)) - 1]} ${k.slice(0, 4)}` : "—");

export const MonthRangePicker = ({ start, end, onChange }) => {
  const [year, setYear] = useState(Number((end || start || key(new Date().getFullYear(), 0)).slice(0, 4)));
  const [picking, setPicking] = useState(false);
  const pick = (k) => {
    if (!picking) { onChange({ start: k, end: k }); setPicking(true); return; }
    onChange(k < start ? { start: k, end: start } : { start, end: k });
    setPicking(false);
  };
  return (
    <div className="month-picker" data-testid="month-range-picker">
      <div className="month-picker-head">
        <button type="button" onClick={() => setYear(year - 1)} aria-label="Année précédente" data-testid="month-picker-prev"><ChevronLeft size={13} /></button>
        <strong data-testid="month-picker-year">{year}</strong>
        <button type="button" onClick={() => setYear(year + 1)} aria-label="Année suivante" data-testid="month-picker-next"><ChevronRight size={13} /></button>
      </div>
      <div className="month-picker-grid">
        {MONTHS.map((m, i) => {
          const k = key(year, i);
          const edge = k === start || k === end;
          const inside = start && end && k > start && k < end;
          return <button key={k} type="button" className={edge ? "month-on" : inside ? "month-in" : ""} onClick={() => pick(k)} data-testid={`month-picker-${k}`}>{m}</button>;
        })}
      </div>
      <p className="month-picker-sum" data-testid="month-picker-summary">{picking ? "Choisissez le mois de fin" : `${label(start)} → ${label(end)}`}</p>
    </div>
  );
};
